import Modal from '../ui/Modal';
import Button from '../ui/Button';
import EstadoActivoPill from './EstadoActivoPill';

function VisualizarTipoConceptoModal({ isOpen, onClose, item }) {
  if (!item) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Detalle del tipo de concepto"
      description="Información completa del registro"
      size="md"
      footer={
        <Button variant="secondary" onClick={onClose}>
          Cerrar
        </Button>
      }
    >
      <dl className="divide-y divide-white/5 overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03]">
        <div className="flex items-center justify-between gap-4 px-4 py-3 sm:px-5">
          <dt className="text-[11px] font-mono uppercase tracking-[0.18em] text-white/45">
            Acrónimo
          </dt>
          <dd className="font-mono text-sm text-white/90">{item.tpConcepto}</dd>
        </div>
        <div className="flex items-center justify-between gap-4 px-4 py-3 sm:px-5">
          <dt className="text-[11px] font-mono uppercase tracking-[0.18em] text-white/45">
            Tipo de concepto
          </dt>
          <dd className="text-right text-sm font-medium text-white/90">
            {item.deTipoConcepto}
          </dd>
        </div>
        <div className="flex items-center justify-between gap-4 px-4 py-3 sm:px-5">
          <dt className="text-[11px] font-mono uppercase tracking-[0.18em] text-white/45">
            Estatus
          </dt>
          <dd>
            <EstadoActivoPill status={item.stTipoConcepto} />
          </dd>
        </div>
      </dl>
    </Modal>
  );
}

export default VisualizarTipoConceptoModal;